import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=98a9c6e0&scoped=true&"
var script = {}
import style0 from "./Mobile.vue?vue&type=style&index=0&id=98a9c6e0&prod&scoped=true&lang=css&"
import style1 from "./Mobile.vue?vue&type=style&index=1&id=98a9c6e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a9c6e0",
  null
  
)

export default component.exports